import React from "react";
import WaitingGif from "@/assets/interview/aiprofile/waiting.gif";
import SpeakingGif from "@/assets/interview/aiprofile/speaking.gif";
import ListeningGif from "@/assets/interview/aiprofile/listening.gif";
import StillStateGif from "@/assets/interview/aiprofile/still-state.gif";
import LogoIconWithGradient from "@/assets/interview/aiprofile/logo-icon-gradient.svg";

interface AIProfileProps {
  interviewState: "PROCESSING" | "LISTENING" | "SPEAKING" | "AI_RETRYING" | "CODING_EXERCISE" | "IMPROVING_SPEECH" | "AWAIT_SUBMIT";
  height?: string;
  isAiRetrying: boolean;
}

const AIProfile: React.FC<AIProfileProps> = ({ interviewState, height = "100%", isAiRetrying }) => {
  // Select the appropriate GIF based on the interview state
  const getGif = () => {
    switch (interviewState) {
      case "PROCESSING":
        return WaitingGif;
      case "IMPROVING_SPEECH":
        return WaitingGif;
      case "LISTENING":
        return ListeningGif;
      case "SPEAKING":
        return SpeakingGif;
      case "AI_RETRYING":
        return isAiRetrying ? StillStateGif : WaitingGif;
      case "CODING_EXERCISE":
        return WaitingGif;
      case "AWAIT_SUBMIT":
        return WaitingGif;
      default:
        return WaitingGif;
    }
  };

  const getLabel = () => {
    switch (interviewState) {
      case "CODING_EXERCISE":
        return "Code Exercise";
      default:
        return interviewState
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
    }
  };

  return (
    <div
      className="relative w-full flex flex-col items-center justify-center overflow-hidden border border-[#0000001A] rounded-lg bg-white p-4 h-full"
      style={{ height, minHeight: height }}
    >
      <img src={LogoIconWithGradient} className="w-[150px] mt-2 ml-5 md:w-[100px] lg:w-[120px]" alt="Logo" />

      {/* AI Status GIF */}
      {isAiRetrying ? (
        <>
          <img src={StillStateGif} className="w-[250px] h-[120px] object-contain" alt="AI Status" />
          <p className="font-dm-sans">AI retrying...</p>
        </>
      ) : (
        <>
          <img src={getGif()} className="w-[160px] h-[80px] lg:w-[100px] lg:h-[50px] object-contain md:w-[100px] md:h-[50px]" alt="AI Status" />
          <p className="font-dm-sans text-[#68696b] text-[16px] md:text-[10px] lg:text-[11px] xl:text-[15px]">{getLabel()}{interviewState === 'AWAIT_SUBMIT' ? '' : '...'}</p>
        </>
      )}
    </div>
  );
};

export default AIProfile;
